<div>
    <vl-info-tile tag-name="div" :title="organisationInvoiceGroupName">
        <template v-slot:headerextension v-if="!readOnly">
            <vl-action-group>
                <vl-button type="button" icon="bin" @click="deleteInvoiceGroup" mod-icon mod-error mod-secondary hidden-text="Verwijder facturatiegroep" />
                <vl-button type="button" icon="pencil" @click="updateInvoiceGroup" mod-icon mod-secondary hidden-text="Bewerk facturatiegroep" />
            </vl-action-group>
        </template>
        <vl-form-grid mod-stacked mod-v-center>
            <vl-column width="12">
                <p v-if="organisationInvoiceGroup.attention">
                    <span v-vl-text.light>Ter attentie van:</span> {{organisationInvoiceGroup.attention}}
                </p>
                <p v-if="organisationInvoiceGroup.reference">
                    <span v-vl-text.light>Eigen referentie:</span> {{organisationInvoiceGroup.reference}}
                </p>
                <p v-if="organisationInvoiceGroup.reminderEmail">
                    <span v-vl-text.light>E-mailadres voor factuurherinneringen:</span> {{organisationInvoiceGroup.reminderEmail}}
                </p>
            </vl-column>
            <vl-column width="12" v-if="hasContactInfo">
                <vl-title tag-style="h6">Contactpersoon i.v.m. facturatie</vl-title>
                <p v-if="organisationInvoiceGroup.invoiceContactName">
                    {{ organisationInvoiceGroup.invoiceContactName }}
                </p>
                <p v-if="organisationInvoiceGroup.invoiceContactEmail">
                    <vl-link :href="`mailto:${organisationInvoiceGroup.invoiceContactEmail}`" icon="mail" mod-icon-before>{{ organisationInvoiceGroup.invoiceContactEmail }}</vl-link>
                </p>
                <p v-if="organisationInvoiceGroup.invoiceContactPhoneNumber">
                    <ippro-icon-text icon="phone">{{ organisationInvoiceGroup.invoiceContactPhoneNumber }}</ippro-icon-text>
                </p>
            </vl-column>
            <vl-column width="12"></vl-column>
            <vl-column width="6" v-for="organisation in organisationInvoiceGroup.organisations" :key="organisation.memberKlipOrganisationId">
                <vl-info-tile
                    tag-name="div"
                    :title="organisation.organisationPath" />
            </vl-column>
        </vl-form-grid>
    </vl-info-tile>
</div>
